module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-178.8af9572.woff2";